import { useSelector } from "react-redux";

/**
 * Adaptive UI: does this company run a FULL PTN setup (control box / encoders /
 * decoders → per-screen routing) or a SIMPLE one (Player + HDMI splitter → all
 * screens show the same thing)?
 *
 * Sourced from /company/details (`has_ptn_hardware`), which CompanyDetailsRouter
 * stores in redux — synchronous, no extra request, no flicker (mirrors
 * useIsRestaurant). The admin configuring hardware (or not) flips this; the user
 * UI adapts automatically.
 *
 * Fail-safe to SIMPLE (false) while loading/unknown, so the advanced
 * Sources/Screens/Routing surfaces only appear once PTN is confirmed present.
 */
export function useHasHardware() {
  return useSelector((s) => !!s.global?.companyDetails?.has_ptn_hardware);
}
